import { IPreloadedState } from 'shared/types/redux';

export const selectIsInlineFiltersRedesigned = (state: IPreloadedState) => state.isInlineFiltersRedesigned || false;
